export default [
  {
    path: "/login",
    name: "login",
    meta: {
      keepAlive: false,
      isBack: false
    },
    component: () => import("@/views/login")
  },
  {
    path: "/",
    component: () => import('@/views/admin'),
    name: "admin",
    meta: {
      keepAlive: false,
      isBack: false
    },
    children: [
      {
        path: 'ffi',
        name: 'ffi',
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/ffi/ffi"),
        children: [
          {
            path: "userKey",
            name: "userKey",
            meta: {
              keepAlive1: true,
              isBack: false
            },
            props: true,
            component: () => import("@/views/ffi/userKey")
          },
          {
            path: "apiRecords",
            name: "apiRecords",
            meta: {
              keepAlive1: false,
              isBack: false
            },
            props: true,
            component: () => import("@/views/ffi/apiRecords")
          },
          {
            path: "connectionRecords",
            name: "connectionRecords",
            meta: {
              keepAlive1: false,
              isBack: false
            },
            props: true,
            component: () => import("@/views/ffi/connectionRecords")
          },
          {
            path: "activedUser",
            name: "activedUser",
            meta: {
              keepAlive1: false,
              isBack: false
            },
            props: true,
            component: () => import("@/views/ffi/activedUser")
          }
        ]
      },
      {
        path: "taskAdmin",
        name: "taskAdmin",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/task/taskAdmin")
      },
      {
        path: "taskHistory",
        name: "taskHistory",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/task/taskHistory")
      },
      {
        path: "userinfo",
        name: "userinfo",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/user/userinfo")
      },
      {
        path: "bindCanteen",
        name: "bindCanteen",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/dishModel/bindCanteen")
      },
      {
        path: "dishModelManagement",
        name: "dishModelManagement",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/dishModel/dishModelManagement")
      },
      {
        path: "dishDataCheck",
        name: "dishDataCheck",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/dishModel/dishDataCheck")
      },
      {
        path: "dishCheck",
        name: "dishCheck",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/dishModel/dishCheck")
      },

      {
        path: "dishCheckProcess",
        name: "dishCheckProcess",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/dishModel/dishCheckProcess")
      },
      {
        path: "/dataMark/",
        name: "dataMark",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/dataMark"),
        children: [
          {
            path: "batchList",
            name: "batchList",
            meta: {
              keepAlive: false,
              isBack: false
            },
            component: () => import("@/views/dataMark/batchList")
          },
          {
            path: "checkList",
            name: "checkList",
            meta: {
              keepAlive: false,
              isBack: false
            },
            component: () => import("@/views/dataMark/batchList")
          },
          {
            path: "markProcess",
            name: "markProcess",
            meta: {
              keepAlive: false,
              isBack: false
            },
            component: () => import("@/views/dataMark/markProcess")
          },
          {
            path: "checkProcess",
            name: "checkProcess",
            meta: {
              keepAlive: false,
              isBack: false
            },
            component: () => import("@/views/dataMark/checkProcess")
          },
          {
            path: "markProcess1",
            name: "markProcess1",
            meta: {
              keepAlive: false,
              isBack: false
            },
            component: () => import("@/views/dataMark/markProcess1")
          }
        ]
      },
      {
        path: "trainTask",
        name: "trainTask",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/trainModel")
      },
      {
        path: "moduleAdmin",
        name: "moduleAdmin",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("_v/moduleAdmin/moduleAdmin")
      },
      {
        path: "trainModel",
        name: "trainModel",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/trainModel/trainModel")
      },
      {
        path: "canteenAdmin",
        name: "canteenAdmin",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/canteenAdmin")
      },
      {
        path: "canteenList",
        name: "canteenList",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/canteen/canteenList")
      },
      {
        path: "analysis",
        name: "analysis",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/analysis")
      },
      {
        path: "detectedImageCheck",
        name: "detectedImageCheck",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/analysis/detectedImageCheck")
      },
      {
        path: "unCheckDetectedList",
        name: "unCheckDetectedList",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/analysis/unCheckDetectedList")
      },
      {
        path: "unCheckBackDataList",
        name: "unCheckBackDataList",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/backDataCheck/unCheckBackDataList")
      },
      {
        path: "backDataImageCheck",
        name: "backDataImageCheck",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/analysis/backDataImageCheck")
      },
      {
        path: "imageCheckBeforeNewTask",
        name: "imageCheckBeforeNewTask",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/trainModel/imageCheckBeforeNewTask")
      },
      {
        path: "taskHistoryByBatch",
        name: "taskHistoryByBatch",
        meta: {
          keepAlive: true
        },
        component: () => import("@/views/trainModel/taskHistoryByBatch")
      },
      {
        path: "newTaskMark",
        name: "newTaskMark",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/trainModel/newTaskMark")
      },
      {
        path: "backDataAccSummary",
        name: "backDataAccSummary",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/analysis/backDataAccSummary")
      },
      {
        path: "backDataAccByCanteen",
        name: "backDataAccByCanteen",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/analysis/backDataAccByCanteen")
      },
      {
        path: "backDataImageMark",
        name: "backDataImageMark",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () =>
          import("@/views/analysis/backDataImageMarkWithMultiDrag")
      },
      // {
      //   path: 'backDataImageMark',
      //   name: 'backDataImageMark',
      // meta: {keepAlive: false},
      //   component: () => import('@/views/analysis/backdataImageMark')
      // },
      {
        path: "batchUpload",
        name: "batchUpload",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/upload/batchUpload")
      },
      {
        path: "eventManagement",
        name: "eventManagement",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/eventManagement")
      },
      {
        path: "userAdmin",
        name: "userAdmin",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/user/useradmin")
      },
      {
        path: "machineAdmin",
        name: "machineAdmin",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/machineAdmin")
      },
      {
        path: "checkResult",
        name: "checkResult",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/trainModel/checkResult")
      },
      {
        path: "checkResult/details",
        name: "checkResultdetails",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/trainModel/checkResultdetails")
      },
      {
        path: "taskHistoryRecheck",
        name: "taskHistoryRecheck",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/task/taskHistoryRecheck")
      },
      {
        path: "backDataMultiDragBeforeNewTask",
        name: "backDataMultiDragBeforeNewTask",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/task/backDataMultiDragBeforeNewTask")
      },
      {
        path: "regionsFix",
        name: "regionsFix",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/region/region")
      },
      // {
      //   path: "paymentModuleAdmin",
      //   name: "paymentModuleAdmin",
      //   meta: {
      //     keepAlive: false,
      //     isBack: false
      //   },
      //   component: () => import("@/views/modulesAdmin/paymentModuleAdmin")
      // },
      {
        path: "test",
        name: "test",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("@/views/test/test")
      },
      {
        path: "migrationCheck",
        name: "migrationCheck",
        meta: {
          keepAlive: false,
          isBack: false
        },
        component: () => import("_v/migration/migrationCheck.vue")
      }
      ]
  }
];
